var vars = require('./core');

module.exports = vars.createClass('Bar', ['getBarsAtEvent']);



/*****************
 ** WEBPACK FOOTER
 ** ../~/react-chartjs/lib/bar.js
 ** module id = 817
 ** module chunks = 2
 **/